var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Calculator"}},[_c('Calculator',{attrs:{"project":_vm.mainProject,"value":_vm.amount},on:{"update:value":function($event){_vm.amount=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }